import React from 'react';
import { relativeZindexStyle } from '../modules/utils';

interface ImageProps {
    image: string;
    classes: string;
    style?: React.CSSProperties;
}
const LazyloadImage = ({ image, classes, style }: ImageProps) => {
    const classNames = `${classes} lazyload`;
    const styleAttributes = style ? style : relativeZindexStyle;
    return (
        <img
            data-src={image}
            className={classNames}
            style={styleAttributes}
        ></img>
    );
};
export default LazyloadImage;
